import { NavUtils } from '0-app-desktop/util/nav-utils';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'error-404',
    standalone: true,
    templateUrl: './error-404.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoModule, MatButtonModule,MatIconModule,],
})
export class Error404Component {
    /**
     * Constructor
     */
    private navUtils = inject(NavUtils);
    constructor() {}

    goHome() {
        this.navUtils.goHome();
    }
}
